


































import { defineComponent } from '@vue/composition-api';
import Title from './title.vue';
export default defineComponent({
  name: 'HeaderImage',
  props: {
    colorStyle: {
      type: String,
      required: true,
    },
    headerConfig: {
      type: Object,
      required: true,
    },
    isShowBigHeader: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Title,
  },

  setup() {
  },
});

